
/*
 * Pages that DO NOT show the secondary MUI tab bar.
 * Keep the list in regex form – it is unambiguous and works
 * for “variable-segment” routes such as /providers/123
 */

console.log('[pathUtils]  live file:', __filename);


export const NON_TABBED_REGEXES = [
  /^\/login(\/|$)/,
  /^\/login_settings(\/|$)/,
  /^\/print(\/|$)/,                        // /print   or  /print/*
  /^\/activity(\/|$)/,
  /^\/upload(\/|$)/,
  /^\/rvu_benchmarks(\/|$)/,
  /^\/procedures(\/|$)/,
  /^\/taxonomy(\/|$)/,
  /^\/clients(\/|$)/,
  /^\/users(\/|$)/,
  /^\/label_types(\/|$)/,

  // Provider LIST is tabbed, detail pages are NOT:
  /^\/providers\/[^/]+(\/|$)/,             // /providers/55
  /^\/contacts\/[^/]+(\/|$)/,     
  /^\/locations\/[^/]+(\/|$)/,    
  /^\/organizations\/[^/]+(\/|$)/,
  // Add any other “detail” routes that have no tabs:
//  /^\/labels\/[^/]+(\/|$)/,                // /labels/55
];

/**
 * Returns true when the pathname belongs to a page
 * that DOES have tabs.
 */
export function isTabbedPage(pathname = '') {
  const p   = pathname.toLowerCase();
  const hit = NON_TABBED_REGEXES.find((rx) => rx.test(p));

  /* DEBUG ─────────────────────────────────────────── */
  if (process.env.NODE_ENV !== 'production') {
    console.log('[isTabbedPage] path:', p,
                'matched-by:', hit ? hit.toString() : 'none');
  }
  /* ───────────────────────────────────────────────── */

  return !hit;
}
